/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Intensity_ModerateInputs */

const en_us2_profile_editors_pain_intensity_moderate = /** @type {(inputs: Profile_Editors_Pain_Intensity_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`moderate`)
};

const pt_br2_profile_editors_pain_intensity_moderate = /** @type {(inputs: Profile_Editors_Pain_Intensity_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`moderada`)
};

const es_419_profile_editors_pain_intensity_moderate = /** @type {(inputs: Profile_Editors_Pain_Intensity_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`moderado`)
};

const pt_pt2_profile_editors_pain_intensity_moderate = /** @type {(inputs: Profile_Editors_Pain_Intensity_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`moderada`)
};

const fr_fr2_profile_editors_pain_intensity_moderate = /** @type {(inputs: Profile_Editors_Pain_Intensity_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`modérée`)
};

const de_de2_profile_editors_pain_intensity_moderate = /** @type {(inputs: Profile_Editors_Pain_Intensity_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mäßig`)
};

const it_it2_profile_editors_pain_intensity_moderate = /** @type {(inputs: Profile_Editors_Pain_Intensity_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`moderato`)
};

/**
* | output |
* | --- |
* | "moderate" |
*
* @param {Profile_Editors_Pain_Intensity_ModerateInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_intensity_moderate = /** @type {((inputs?: Profile_Editors_Pain_Intensity_ModerateInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Intensity_ModerateInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_intensity_moderate(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_intensity_moderate(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_intensity_moderate(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_intensity_moderate(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_intensity_moderate(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_intensity_moderate(inputs)
	return en_us2_profile_editors_pain_intensity_moderate(inputs)
});
export { profile_editors_pain_intensity_moderate as "profile-editors.pain_intensity_moderate" }